const toastPlugin = {
  install: (Vue, { store }) => {
    if (!store) {
      throw new Error("Something Went Wrong.");
    }
    // type : 1 -> error, 2 -> success, 3 -> warning
    Vue.prototype.$toast = {
      setMessage: function ({ content = "", type = 1 }) {
        store.commit("SET_MESSAGE", { content, type }, { root: true });
      },
    };
  },
};
export default toastPlugin;
